import {isNil} from 'lodash';
import {createAction} from 'redux-actions';
import {stateWithholding} from '../../../utils/api/api-endpoint-dictionary';
import callApi from '../../../utils/api/axios';

const STATE_WITHHOLDING = 'STATE_WITHHOLDING';

function createStateWithholdingMap(data) {

  const stateLookup = {};
  if ( isNil(data) ){
    return stateLookup;
  }

  data.forEach(withholdingData => {
    if ( withholdingData.stateCode ) {
      stateLookup[withholdingData.stateCode] = withholdingData;
    }
  });
  return stateLookup;
}

export default function StateWithholding(state = {
  isLoaded: false,
  isLoading: false,
  hasFailed: false,
  error: null,
  withholdingData: null,
  stateLookup: {}
}, { payload, type }) {
  switch (type) {
    case `${STATE_WITHHOLDING}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true
      };
    case `${STATE_WITHHOLDING}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
        withholdingData: payload.data,
        stateLookup: createStateWithholdingMap(payload.data)
      };
    case `${STATE_WITHHOLDING}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload.body
      };
    default:
      return state;
  }
}

export const getStateWithholdingData = () => {
  return dispatch => {
    const action = createAction(STATE_WITHHOLDING)(callApi(stateWithholding));
    return dispatch(action);
  };
};
